import {
  CostOptimization,
  ExternalProviderKind,
  OptimizationItemKind,
  ProviderExtras,
} from "@web-app/types";

export type SeededDraft = {
  dspWorkspaceIds: string[];
  externalProviders: ExternalProviderKind[];
  items: { itemId: string; kind: OptimizationItemKind }[];
  overrides: Record<string, string>;
  providerExtras: ProviderExtras;
};

export function seedFromDraft(draft: CostOptimization): SeededDraft {
  const dspIds = new Set<string>();
  const externalKinds = new Set<ExternalProviderKind>();
  const overrides: Record<string, string> = {};

  draft.items.forEach((item) => {
    item.candidates.forEach((candidate) => {
      if (candidate.providerKind) {
        externalKinds.add(candidate.providerKind as ExternalProviderKind);
      } else if (candidate.dspWorkspaceId) {
        dspIds.add(candidate.dspWorkspaceId);
      }
    });
    if (item.assignedDspId) {
      dspIds.add(item.assignedDspId);
      overrides[item.itemId] = item.assignedDspId;
    } else if (item.assignedProviderKind) {
      externalKinds.add(item.assignedProviderKind as ExternalProviderKind);
      overrides[item.itemId] = `external:${item.assignedProviderKind}`;
    }
  });

  (draft.externalProviders ?? []).forEach((kind) => externalKinds.add(kind));

  return {
    dspWorkspaceIds: Array.from(dspIds),
    externalProviders: Array.from(externalKinds),
    items: draft.items.map((item) => ({
      itemId: item.itemId,
      kind: item.kind,
    })),
    overrides,
    providerExtras: draft.providerExtras ?? {},
  };
}
